import { AxiosInstance } from 'axios'

import { toGsResponse } from '../../goodstack'

import { GetPartnerConfigResponse } from './getPartnerConfig.types'

export const getPartnerConfig = async (client: AxiosInstance): Promise<GetPartnerConfigResponse | undefined> =>
  client
    .get<GetPartnerConfigResponse>(`v1/partner/giving/config`, {
      withCredentials: true,
      validateStatus: code => [200, 404].includes(code)
    })
    .then(r => toGsResponse(r.status, r.data))
    .then(r => (r.result === 'success' ? r : undefined))
    .catch(() => undefined)
